export function hasOther(list, values) {
  return !!list && !!list.show && !!list.other && Array.isArray(values) && values.indexOf(list.other) !== -1;
}

export function otherMissing(list, values, text) {
  return hasOther(list, values) && !(typeof text === 'string' && text.trim());
}

export function clearOther(model, key, list) {
  if (!hasOther(list, model[key]) && model[key + 'Other']) {
    model[key + 'Other'] = '';
  }
}
